module.exports = __webpack_public_path__ + "img/40.bd1826f9.jpg";